export const getCroppedImg = (imageSrc, croppedAreaPixels) => {
    return new Promise((resolve, reject) => {
        const image = new Image();
        image.src = imageSrc;
        image.crossOrigin = 'anonymous';

        image.onload = () => {
            const canvas = document.createElement('canvas');
            canvas.width = croppedAreaPixels.width;
            canvas.height = croppedAreaPixels.height;

            const ctx = canvas.getContext('2d');

            ctx.drawImage(
                image,
                croppedAreaPixels.x,
                croppedAreaPixels.y,
                croppedAreaPixels.width,
                croppedAreaPixels.height,
                0,
                0,
                croppedAreaPixels.width,
                croppedAreaPixels.height
            );

            canvas.toBlob((blob) => {
                if (!blob) {
                    return reject(new Error('Canvas is empty'));
                }
                const file = new File([blob], 'cropped.jpg', { type: 'image/jpeg' });
                resolve(file);
            }, 'image/jpeg');
        };

        image.onerror = (err) => {
            reject(err);
        };
    });
};

export const getSquaredImageWithBackground = (imageSrc, backgroundColor = '#ffffff') => {
    return new Promise((resolve, reject) => {
        const image = new Image();
        image.src = imageSrc;
        image.crossOrigin = 'anonymous';

        image.onload = () => {
            const squareSize = Math.max(image.width, image.height);
            const canvas = document.createElement('canvas');
            canvas.width = squareSize;
            canvas.height = squareSize;

            const ctx = canvas.getContext('2d');
            ctx.fillStyle = backgroundColor;
            ctx.fillRect(0, 0, squareSize, squareSize);

            const x = (squareSize - image.width) / 2;
            const y = (squareSize - image.height) / 2;
            ctx.drawImage(image, x, y, image.width, image.height);

            canvas.toBlob((blob) => {
                if (!blob) {
                    return reject(new Error('Canvas is empty'));
                }
                const file = new File([blob], 'square-white-bg.jpg', { type: 'image/jpeg' });
                resolve(file);
            }, 'image/jpeg');
        };

        image.onerror = (err) => {
            reject(err);
        };
    });
};

